
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAbroad = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 1201 1200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m960.338 244.209-.739-.741c-37.813-35.958-113.324 27.904-113.324 27.904L709.18 379.305l-144.326-25.579c20.82-30.182 27.092-60.145 13.211-74.026-17.979-17.979-62.932-2.176-100.401 35.294a194.654 194.654 0 0 0-17.59 20.163l-110.818-19.641-73.816 62.896 300.901 138.072-192.907 233.092-120.148-22.525-30.428 30.384 213.519 213.513 30.38-30.426-22.525-120.15 233.094-192.907 138.072 300.899 62.895-73.816-19.64-110.818a194.538 194.538 0 0 0 20.165-17.589c37.469-37.47 53.273-82.421 35.296-100.398-13.885-13.883-43.85-7.609-74.032 13.21l-25.579-144.325 107.933-137.097s63.864-75.511 27.902-113.322z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"60\" height=\"60\" viewBox=\"0 0 1201 1200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"m960.338 244.209-.739-.741c-37.813-35.958-113.324 27.904-113.324 27.904L709.18 379.305l-144.326-25.579c20.82-30.182 27.092-60.145 13.211-74.026-17.979-17.979-62.932-2.176-100.401 35.294a194.654 194.654 0 0 0-17.59 20.163l-110.818-19.641-73.816 62.896 300.901 138.072-192.907 233.092-120.148-22.525-30.428 30.384 213.519 213.513 30.38-30.426-22.525-120.15 233.094-192.907 138.072 300.899 62.895-73.816-19.64-110.818a194.538 194.538 0 0 0 20.165-17.589c37.469-37.47 53.273-82.421 35.296-100.398-13.885-13.883-43.85-7.609-74.032 13.21l-25.579-144.325 107.933-137.097s63.864-75.511 27.902-113.322z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/abroad.eb127b19f5c85f7de2f7088e26a1850e.svg"),
        {
          React: SvgAbroad,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      